<div class="no-data-container">
  <img class="product-img" style="margin-top: 100px;" src="/assets/e-commerce/icons/72.webp" />
  <p class="no-data-text">
    {{ "no internet" | transloco}}

  </p>

</div>